"use strict";

/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var client_1 = require("react-dom/client");
var App_1 = __importDefault(require("./App"));
/**
 * The ReactDOM process should only be used when developing, or else we will get an invalid
 * hook call when trying to import the component from the build, seeing two react libraries
 * (one in here, and one in the repo we are importing to)
 */
if (process.env.REACT_APP_RENDER) {
  var container = document.getElementById('root');
  var root = (0, client_1.createRoot)(container);
  root.render((0, App_1.default)());
}
// Modules
__exportStar(require("./modules"), exports);
// Viz Typing
__exportStar(require("./constants"), exports);